import Router from 'next/router';
import { useCallback } from 'react';

import { QueryParamNames } from '~/constants/search';
import { useGoToPrivateAssetPage } from '~/hooks/useGoToPrivateAssetPage';
import { getClipIdFromPath } from '~/utils/PathUtils';

export const useWorkspaceUploadsOpenCompletedAsset = () => {
  const { goToAssetPage } = useGoToPrivateAssetPage();

  const openCompletedAsset = useCallback(
    (clipId: string) => {
      const isClipRouteActive = Boolean(getClipIdFromPath(Router.asPath));

      goToAssetPage({
        asset: { id: clipId },
        isAssetModalAlreadyOpen: isClipRouteActive,
        query: {
          [QueryParamNames.amTab]: null,
          [QueryParamNames.discussionId]: null,
        },
        trackLocation: 'card-click',
      });
    },
    [goToAssetPage],
  );

  return { openCompletedAsset };
};
